import { trigger, style, animate, transition, query, animateChild, group } from '@angular/animations';

export const slideInAnimation = [
  trigger('routeAnimations', [
    transition('* <=> *', [
      style({ position: 'relative' }),
      query(':enter, :leave', [
        style({
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
        }),
      ]),
      query(':enter', [style({ left: '-100%' })]),
      query(':leave', animateChild()),
      group([
        query(':leave', [animate('300ms ease-out', style({ left: '100%' }))]),
        query(':enter', [animate('300ms ease-out', style({ left: '0%' }))]),
      ]),
      query(':enter', animateChild()),
    ]),
  ]),
];

export const inOutAnimation = [
  trigger('inOutAnimation', [
    transition(':enter', [
      style({ opacity: 0 }),
      animate(
        '800ms',
        style({
          opacity: 1,
        })
      ),
    ]),
    transition(':leave', [
      style({ opacity: 1 }),
      animate(
        '400ms',
        style({
          opacity: 0,
          height: 0,
        })
      ),
    ]),
  ]),
];
